/**
 * @fileoverview Street and exterior-number fields for the second company address.
 */

import React from "react";
import { IconButton } from "@mui/material";
import ToggleOffIcon from "@mui/icons-material/ToggleOff";
import ToggleOnIcon from "@mui/icons-material/ToggleOn";
import styles from "./Location.module.css";
import {
  CURSOR_NOT_ALLOWED,
  SHOW_IN_PROFILE_KEY,
  TOGGLE_COLOR_ACTIVE,
  TOGGLE_COLOR_INACTIVE,
} from "./locationConstants";

const SecondAddressStreetFields = ({ model, t }) => {
  const {
    getFieldValidationState, getErrorMessage,
    handleInputChange, handleFieldChange,
    handleToggleChange, isAddressReadOnly,
    segundoDomicilioCalle, setSegundoDomicilioCalle,
    segundoDomicilioMostrarCalle, setSegundoDomicilioMostrarCalle,
    segundoDomicilioNumeroExterior, setSegundoDomicilioNumeroExterior,
    segundoDomicilioMostrarNumeroExterior, setSegundoDomicilioMostrarNumeroExterior,
  } = model;

  return (
    <>
      <div className={styles.inputGroup}>
        <label className={styles.inputLabel}>
          {t("components.location.streetLabel")}
        </label>
        <input
          type="text"
          className={`${styles.input} ${
            getFieldValidationState(
              "domicilio2Calle",
              segundoDomicilioCalle,
            ) === "error"
              ? styles.inputError
              : ""
          }`}
          placeholder={t("components.location.streetPlaceholder")}
          onChange={(e) => {
            const value = e.target.value;
            setSegundoDomicilioCalle(value);
            handleInputChange("domicilio2Calle", value);
            handleFieldChange("domicilio2Calle", value);
          }}
          value={segundoDomicilioCalle}
          maxLength={100}
          disabled={true}
          style={{ cursor: CURSOR_NOT_ALLOWED }}
        />
        {getErrorMessage("domicilio2Calle") && (
          <p className={styles.errorMessage}>
            {getErrorMessage("domicilio2Calle")}
          </p>
        )}
        <div className={styles.showInProfileContainer}>
          <span className={styles.showInProfileText}>
            {t(SHOW_IN_PROFILE_KEY)}
          </span>
          <IconButton
            onClick={() => {
              setSegundoDomicilioMostrarCalle(!segundoDomicilioMostrarCalle);
              handleToggleChange(
                "domicilio2MostrarCalle",
                !segundoDomicilioMostrarCalle,
              );
            }}
            size="small"
            disabled={isAddressReadOnly}
            className={styles.toggleButton}
            sx={{
              "&.Mui-disabled": {
                cursor: CURSOR_NOT_ALLOWED,
                pointerEvents: "auto",
              },
              "& .MuiSvgIcon-root": {
                color: segundoDomicilioMostrarCalle
                  ? TOGGLE_COLOR_ACTIVE
                  : TOGGLE_COLOR_INACTIVE,
              },
            }}
          >
            {segundoDomicilioMostrarCalle ? (
              <ToggleOnIcon />
            ) : (
              <ToggleOffIcon />
            )}
          </IconButton>
        </div>
      </div>
      <div className={styles.inputGroup}>
        <label className={styles.inputLabel}>
          {t("components.location.outdoorNumberLabel")}
        </label>
        <input
          type="text"
          className={`${styles.input} ${
            getFieldValidationState(
              "domicilio2NumeroExterior",
              segundoDomicilioNumeroExterior,
            ) === "error"
              ? styles.inputError
              : ""
          }`}
          placeholder={t("components.location.outdoorNumberPlaceholder")}
          onChange={(e) => {
            const value = e.target.value;
            setSegundoDomicilioNumeroExterior(value);
            handleInputChange("domicilio2NumeroExterior", value);
            handleFieldChange("domicilio2NumeroExterior", value);
          }}
          value={segundoDomicilioNumeroExterior}
          maxLength={10}
          disabled={true}
          style={{ cursor: CURSOR_NOT_ALLOWED }}
        />
        {getErrorMessage("domicilio2NumeroExterior") && (
          <p className={styles.errorMessage}>
            {getErrorMessage("domicilio2NumeroExterior")}
          </p>
        )}
        <div className={styles.showInProfileContainer}>
          <span className={styles.showInProfileText}>
            {t(SHOW_IN_PROFILE_KEY)}
          </span>
          <IconButton
            onClick={() => {
              setSegundoDomicilioMostrarNumeroExterior(
                !segundoDomicilioMostrarNumeroExterior,
              );
              handleToggleChange(
                "domicilio2MostrarNumeroExterior",
                !segundoDomicilioMostrarNumeroExterior,
              );
            }}
            size="small"
            disabled={isAddressReadOnly}
            className={styles.toggleButton}
            sx={{
              "&.Mui-disabled": {
                cursor: CURSOR_NOT_ALLOWED,
                pointerEvents: "auto",
              },
              "& .MuiSvgIcon-root": {
                color: segundoDomicilioMostrarNumeroExterior
                  ? TOGGLE_COLOR_ACTIVE
                  : TOGGLE_COLOR_INACTIVE,
              },
            }}
          >
            {segundoDomicilioMostrarNumeroExterior ? (
              <ToggleOnIcon />
            ) : (
              <ToggleOffIcon />
            )}
          </IconButton>
        </div>
      </div>
    </>
  );
};

export default SecondAddressStreetFields;
